// Project data. Frontend source of truth.
// Mirrors the future MongoDB `projects` collection schema so it can move there later.
//
// Fields:
//   id, name, url, category, tags[], featured_order|null,
//   thumb (path or URL), brief, before, after, deliverables[], outcome, status

const projects = [
  {
    id: "yasiinsluv",
    name: "Yasiin's Luv",
    url: "https://yasiinsluv.com",
    category: "Websites",
    tags: ["Website Build", "Wellness Brand", "Brand Direction"],
    featured_order: 1,
    thumb: "/showcase/yasiinsluv.webp",
    brief:
      "A doula and family-support practice that needed its inner warmth, cultural depth, and clinical credibility to live on a single screen.",
    before:
      "Personal voice scattered across social posts; no central home that conveyed the practice's premium positioning.",
    after:
      "A bright, dignified site that translates Yasiin's identity into a living digital experience. Service clarity, soft trust, and easy first contact.",
    deliverables: [
      "Website build",
      "Brand voice direction",
      "Service architecture",
      "Lead flow",
    ],
    outcome:
      "A digital home that feels safe, premium, and human. Exactly the tone the work requires.",
    status: "live",
  },
  {
    id: "ghawkfit",
    name: "G Hawk Fit",
    url: "https://ghawkfit.com",
    category: "Websites",
    tags: ["Website Build", "Fitness Brand", "Personal Brand"],
    featured_order: 2,
    thumb: "/showcase/ghawkfit.webp",
    brief:
      "A performance and training brand built around discipline, movement, and the trainer's personal authority.",
    before:
      "Capability without a stage. The standard of the work was higher than the surface that represented it.",
    after:
      "A cinematic training brand experience: dark, intentional, and built around the trainer as the signal.",
    deliverables: [
      "Website build",
      "Visual identity direction",
      "Training library architecture",
      "Membership funnel",
    ],
    outcome:
      "Brand presence finally matches the discipline behind the work.",
    status: "live",
  },
  {
    id: "brandedxbrandy",
    name: "Branded x Brandy",
    url: "https://brandedxbrandy.com",
    category: "Websites",
    tags: ["Website Build", "Personal Brand", "Creative Platform"],
    featured_order: 3,
    thumb: "/showcase/brandedxbrandy.webp",
    brief:
      "A coaching and activation platform for women. Soft power, spiritual grounding, and visible feminine authority.",
    before:
      "A powerful voice with no premium platform to host it; the work outgrew the wrapper.",
    after:
      "A black and gold coaching site that feels sacred, modern, and deeply on-frequency with the founder.",
    deliverables: [
      "Website build",
      "Brand positioning",
      "Offer architecture",
      "Booking flow",
    ],
    outcome:
      "An online home that finally feels like the founder, not a template.",
    status: "live",
  },
  {
    id: "joymackcounseling",
    name: "Joy Mack Counseling",
    url: "https://joymackcounseling.com",
    category: "Websites",
    tags: ["Website Build", "Wellness Brand", "Service Funnel"],
    featured_order: 4,
    thumb: "/showcase/joymackcounseling.webp",
    brief:
      "An emotional wellness practice that needed its first impression to feel like exhale. Safe, soft, and unmistakably premium.",
    before:
      "A practice doing meaningful work without a digital space that matched the calm and care of the sessions.",
    after:
      "A quiet, elegant sanctuary site. Restorative typography, warm photography, and a single clear next step.",
    deliverables: [
      "Website build",
      "Brand voice",
      "Service offerings layout",
      "Booking entry point",
    ],
    outcome:
      "The first impression now does the same thing the sessions do. Let people exhale.",
    status: "live",
  },
  {
    id: "infiniteinspires",
    name: "Infinite Inspires",
    url: "https://infiniteinspires.com",
    category: "Websites",
    tags: ["Website Build", "Spiritual Guidance", "Personal Brand"],
    featured_order: 5,
    thumb: "/showcase/infiniteinspires.webp",
    brief:
      "Jasmine's awakening practice. A vessel for the work she calls Awaken, Real-Eyes, Become. Built to greet the soul that is finally ready to come home to itself.",
    before:
      "A voice tested on the road, carrying language people had never heard articulated this way, with no digital home that could hold the depth of the teaching.",
    after:
      "A soft, sovereign site that opens with stillness. Three movements (Seed & Root, the Infinity Principle, Real-Eyes) carry the reader through Jasmine's framework before any offer is named.",
    deliverables: [
      "Website build",
      "Voice and language direction",
      "Three-movement framework architecture",
      "Food for Thought live series integration",
    ],
    outcome:
      "A doorway that matches the work. Seekers arrive, feel the frequency, and meet Jasmine where she already speaks from.",
    status: "live",
  },
  {
    id: "embracingconnectionsforlife",
    name: "Embracing Connections for Life",
    url: "https://embracingconnectionsforlife.com",
    category: "Websites",
    tags: ["Website Build", "Community Care", "Service Architecture"],
    featured_order: 6,
    thumb: "/showcase/embracingconnectionsforlife.webp",
    brief:
      "Tamar Green's Oregon doula and community care practice. Birth and postpartum support, CPR and First Aid instruction, family navigation, and BIPOC community education unified on a single connected platform.",
    before:
      "Five distinct care areas held by one practitioner, with no shared frame to help families know which door to walk through first.",
    after:
      "One Connected Care System rooted in a Tree of Life centerpiece. Visitors pick the path that fits where they are (expecting, training, caring for family, organizing a team) and Tamar meets them with a clear next step at every entry point.",
    deliverables: [
      "Website build",
      "Service architecture for five care areas",
      "Pick-a-Path entry flow",
      "Trainings and resource navigation system",
    ],
    outcome:
      "A care system families can actually use. Equal care, equal dignity, one steady guide at every step.",
    status: "live",
  },
  {
    id: "your-brand-next",
    name: "Your Brand Could Be Next",
    url: null,
    category: "Coming Soon",
    tags: ["Open Slot", "Brand Direction", "Website Build"],
    featured_order: 7,
    thumb: null, // rendered as a poetic invitation card
    brief:
      "Every build begins with clarity. Start with the Momentum Personal Action Plan and turn your internal direction into an external presence people can feel.",
    before: null,
    after: null,
    deliverables: [
      "Momentum Personal Action Plan",
      "Brand direction",
      "Website buildout",
      "Launch system",
    ],
    outcome:
      "Your direction, made visible. At a level that finally matches the work.",
    status: "open",
  },
];

export const CATEGORIES = [
  "All",
  "Websites",
  "Brand Direction",
  "Funnels",
  "Content",
  "AI-Assisted",
];

export default projects;
